/**
 * Presentation helpers: decimal hours ↔ Hours+Minutes.
 * Storage/API remain decimal hours; round to nearest minute for display only.
 */

export function decimalHoursToHm(decimalHours) {
  const n = Number(decimalHours);
  if (!Number.isFinite(n) || n < 0) return { hours: 0, minutes: 0 };
  const totalMinutes = Math.round(n * 60);
  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
  };
}

export function hmToDecimalHours(hours, minutes) {
  const h = Math.max(0, Math.floor(Number(hours) || 0));
  const m = Math.min(59, Math.max(0, Math.floor(Number(minutes) || 0)));
  return h + (m / 60);
}

/**
 * Human-readable duration, e.g. "1 hr 30 min", "2 hr", "45 min".
 * Display rounds to nearest minute; does not mutate the source decimal.
 */
export function formatHoursHm(decimalHours) {
  const n = Number(decimalHours);
  if (!Number.isFinite(n) || n <= 0) return '0 min';
  const { hours, minutes } = decimalHoursToHm(n);
  if (hours <= 0 && minutes <= 0) return '0 min';
  const parts = [];
  if (hours > 0) parts.push(`${hours} hr`);
  if (minutes > 0) parts.push(`${minutes} min`);
  return parts.join(' ');
}
